export const dataGridPresets = {
    noZebraStripes: {
        componentsProps: {
            row: { "data-atlas-style-no-zebra-stripes": true },
        },
    },
    noHeaderBackground: {
        componentsProps: {
            grid: {
                sx: {},
            },
        },
    },
};
//# sourceMappingURL=dataGrid.js.map